var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-action",class:( _obj = {}, _obj['time-action--' + _vm.color] = _vm.color, _obj )},[_vm._v(" Действует с "+_vm._s(_vm.dateStart)+" по "+_vm._s(_vm.dateEnd)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }